import styles from './TransitionControls.module.css';

// Slider range (seconds). 0 = instant snap; higher = slower, gentler ramp.
const MIN_S = 0;
const MAX_S = 120;
const STEP_S = 5;

// Quick presets the instructor can tap instead of dragging.
const PRESETS = [
  { label: 'Instant', value: 0 },
  { label: '30s', value: 30000 },
  { label: '60s', value: 60000 },
  { label: '120s', value: 120000 },
];

export default function TransitionControls({ store }) {
  const ms = store.transitionDuration;
  const seconds = Math.round(ms / 1000);
  const valueLabel = seconds === 0 ? 'Instant' : `${seconds}s`;

  return (
    <div className={styles.transitionControlsWrapper}>
      <div className={styles.sliderRow}>
        <input
          type="range"
          className={styles.slider}
          min={MIN_S}
          max={MAX_S}
          step={STEP_S}
          value={seconds}
          onChange={(e) => store.setTransitionDuration(Number(e.target.value) * 1000)}
          aria-label="Transition speed"
        />
        <span className={styles.value}>{valueLabel}</span>
      </div>

      <div className={styles.presets}>
        {PRESETS.map((p) => (
          <button
            key={p.value}
            className={`${styles.presetButton} ${ms === p.value ? styles.active : ''}`}
            onClick={() => store.setTransitionDuration(p.value)}
          >
            {p.label}
          </button>
        ))}
      </div>
    </div>
  );
}
